import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { UsageBucket } from "../lib/api";

type Props = {
  buckets: UsageBucket[];
  granularity: "day" | "hour";
};

export function UsageChart({ buckets, granularity }: Props) {
  if (buckets.length === 0) {
    return (
      <div className="flex h-64 items-center justify-center rounded-md border bg-card text-sm text-muted-foreground">
        Keine Verbrauchsdaten im gewählten Zeitraum.
      </div>
    );
  }
  const data = buckets.map((b) => ({
    name:
      granularity === "day"
        ? b.bucket.slice(0, 10)
        : b.bucket.slice(0, 13).replace("T", " ") + ":00",
    Runs: b.run_count,
    "Tool calls": b.tool_calls,
    Tokens: b.prompt_tokens + b.completion_tokens,
  }));
  return (
    <div className="h-64 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 8, right: 24, bottom: 8, left: 0 }}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
          <XAxis dataKey="name" tick={{ fontSize: 11 }} />
          <YAxis yAxisId="left" tick={{ fontSize: 11 }} />
          <YAxis yAxisId="right" orientation="right" tick={{ fontSize: 11 }} />
          <Tooltip />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Line yAxisId="left" type="monotone" dataKey="Runs" stroke="#2563eb" />
          <Line yAxisId="left" type="monotone" dataKey="Tool calls" stroke="#16a34a" />
          <Line yAxisId="right" type="monotone" dataKey="Tokens" stroke="#dc2626" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
